import { useState } from 'react';
import { useStore } from '../../context';
import {
  Button,
  enqueueSnackbar,
  InputContainer,
  SearchableSelect,
  Typography,
} from '../../design-system';
import { containerValidator, formatContainerType, showToRoles } from '../../utils';
import {
  CloseIconButton,
  DashbaordFormFooter,
  DashboardFormPopup,
  DashboardHeader,
  DashboardInputs,
} from '../dashboard';
import { INPUT_ERRORS, MESSAGES } from '../../const';
import { useCreateGateOutsByFilterMutation } from '../../hooks';
import { containersService } from '../../services';

export const GateOutsCreateByFilter = ({
  filter = {},
  isOpen,
  refetch,
  handleFormCloseClick,
}: any) => {
  const {
    state: {
      user: { data: user },
    },
  } = useStore();

  const { mutate } = useCreateGateOutsByFilterMutation();

  const [containerNumber, setContainerNumber] = useState<any[]>([]);
  const [containerId, setContainerId] = useState<any[]>([]);

  const validators: any = {
    containerNumber: !containerNumber.join(', ')
      ? INPUT_ERRORS.REQUIRED.CONTAINER_NUMBER
      : !containerNumber.every((val) => containerValidator(val))
      ? INPUT_ERRORS.NOT_VALID.CONTAINER_NUMBER
      : '',
  };

  const handleOnClose = () => {
    setContainerNumber([]);
    setContainerId([]);
    handleFormCloseClick();
  };

  const handleContainerSelect = (option: any) => {
    if (containerId.includes(option.id)) {
      const i = containerId.indexOf(option.id);
      setContainerNumber(containerNumber.filter((_, n) => n !== i));
      setContainerId(containerId.filter((_, n) => n !== i));
    } else {
      setContainerNumber([option.value, ...containerNumber]);
      setContainerId([option.id, ...containerId]);
    }

    return;
  };

  const handleCreateClick = () => {
    mutate(
      { id: filter.id, containerIds: containerId },
      {
        onSuccess: () => {
          handleOnClose();
          enqueueSnackbar(MESSAGES.GATE_OUT.SUCCESS.CREATED_FROM_FILTER, 'success');
          refetch();
        },
        onError: () => {
          enqueueSnackbar(MESSAGES.GATE_OUT.ERROR.NOT_CREATED_FROM_FILTER, 'error');
        },
      },
    );
  };

  return (
    <DashboardFormPopup isOpen={isOpen}>
      <DashboardHeader>
        <Typography variant={'textXL'} weight={'bold'}>
          Create from filter
          {(showToRoles('admin', user) && `: ${filter?.clientYard?.client?.code}`) || ''}
        </Typography>
        <CloseIconButton onClick={handleOnClose} />
      </DashboardHeader>
      <DashboardInputs>
        <Typography variant={'textM'}>
          Requested Count: {filter.requestedCount}
          {' -> '}
          {containerId.length}
        </Typography>
        {filter.type && (
          <Typography variant={'textM'}>Type: {formatContainerType(filter.type)}</Typography>
        )}
        {filter.condition && (
          <Typography variant={'textM'}>Condition: {filter.condition}</Typography>
        )}
        {filter.clientYard?.clientId && filter.clientYard?.yardId && (
          <SearchableSelect
            InputComponent={InputContainer}
            label={'Container Number'}
            selectedOptionLabel={containerNumber.join(', ') || 'Select Container Number'}
            onSelect={handleContainerSelect}
            queryKey={[
              'container-short',
              'Container Number' +
                `${filter.yardId && filter.clientId ? filter.yardId + filter.clientId : ''}`,
              showToRoles(['SUPER_ADMIN', 'YARD_COMPANY_ADMIN', 'YARD_COMPANY_EMPLOYEE'], user)
                ? filter.yardId && filter.clientId
                  ? `Container Number${filter.yardId + filter.clientId}`
                  : 'Container Number'
                : `Container Number${filter.yardId + filter.clientId}`,
            ]}
            queryFn={() =>
              containersService.options({
                yardId: filter.clientYard?.yardId,
                clientId: filter.clientYard?.clientId,
                hideAwaitingPayment: true,
                status: 'GATED_IN',
                containerIds: filter.containerIds,
                condition: filter.condition,
                type: filter.type,
                short: true,
                isQuery: true,
              })
            }
            selectedAreasEqaul={{ key: 'id', keys: containerId }}
            multiple
            error={!!containerNumber.length && !!validators.containerNumber}
            helperText={!!containerNumber.length && validators.containerNumber}
          />
        )}
      </DashboardInputs>
      <DashbaordFormFooter>
        <Button
          size={'medium'}
          onClick={handleCreateClick}
          disabled={
            !containerId.length ||
            containerId.length > (filter.requestedCount || containerId.length)
          }
        >
          Create
        </Button>
      </DashbaordFormFooter>
    </DashboardFormPopup>
  );
};
